import { drawJersey } from '@/common/assets';
import { useNewTranslations } from '@/common/translations';
import { Section } from '@/ui/components';

import { StatsPreviousMeetings } from '../../../components';
import { ApiWidgetType, StatsTypes } from '../../../constants';
import { useStatsData } from '../../../hooks';

const PreviousMeetings = () => {
  const translate = useNewTranslations();
  const { teams, widget } = useStatsData({
    widgetType: StatsTypes.PREVIOUS_MEETINGS,
  });

  if (!widget || widget.type !== ApiWidgetType.PREVIOUS_MEETINGS || !widget?.data) {
    return null;
  }

  const { homeWins, draws, awayWins } = widget.data;

  return (
    <Section name={translate('PreMatchStats.PreviousMeetings')} contentClassName="py-0">
      <StatsPreviousMeetings
        homeWins={homeWins}
        draws={draws}
        awayWins={awayWins}
        homeJerseySrc={teams.home.jersey}
        drawJerseySrc={drawJersey}
        awayJerseySrc={teams.away.jersey}
      />
    </Section>
  );
};

export default PreviousMeetings;
